import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import { replace } from '../../services/router-utils';
import Menu from '../../components/menu';
import MenuTab from '../../components/menu-tab';
import withTranslate from '../../hoc/with-translate';
import { buttonClicked } from '../../actions/button-clicked';

const TABS = [
  {
    type: 'posts',
    className: 'search-menu__posts-tab',
    title: 'search-menu.posts',
    route: '/search/posts',
  },
  {
    type: 'members',
    className: 'search-menu__profiles-tab',
    title: 'search-menu.members',
    route: '/search/members',
  },
];

const buildTo = (path, location) => `${path}?query=${location.query.query || ''}`;

export class SearchMenu extends Component {
  state = {
    hasNavigated: false,
  };

  componentWillReceiveProps = props => {
    if (this.state.hasNavigated) {
      return;
    }

    const routes = [];
    TABS.forEach(tab => {
      if (props[tab.type].length) {
        routes.push(tab.route);
      }
    });

    if (routes.length === 1) {
      this.navigate(routes[0]);
    }
  };

  handleNavigate = ({ route, type }) => event => {
    this.props.buttonClicked({ name: 'search_tab', type });
    event.preventDefault();
    this.navigate(route);
  };

  navigate = route => {
    this.props.replace(buildTo(route, this.props.location));
    this.setState({ hasNavigated: true });
  };

  render() {
    const { t } = this.props;
    return (
      <Menu>
        {TABS.map((tab, key) => {
          return (
            <MenuTab
              key={key}
              className={classNames(tab.className)}
              title={t(tab.title)}
              count={this.props[tab.type].length}
              isActive={this.props.router.isActive(tab.route)}
              onClick={this.handleNavigate(tab)}
            />
          );
        })}
      </Menu>
    );
  }
}

SearchMenu.propTypes = {
  posts: PropTypes.array.isRequired,
  members: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  replace: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  buttonClicked: PropTypes.func.isRequired,
};

const mapStateToProps = ({ search }) => search;
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      replace,
      buttonClicked,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslate(SearchMenu)));



// WEBPACK FOOTER //
// ./app/containers/search-menu/search-menu.js